import {
    AssetColumn,
    PreviewAssetColumn,
    SearchedAssetColumn,
} from "@features/autocomplete-table/autocomplete-table-columns/autocomplete-table-columns-assets";
import {
    CustomContentColumn,
    MusicContentColumn,
    PeopleContentColumn,
    PhotoContentColumn,
    VideoContentColumn,
} from "@features/autocomplete-table/autocomplete-table-columns/autocomplete-table-columns-contents";
import { CollectionColumn } from "@features/autocomplete-table/autocomplete-table-columns/autocomplete-table-columns-collections";
import { LinkContentColumn } from "@features/autocomplete-table/autocomplete-table-columns/autocomplete-table-columns-links";
import { MixedColumn as SummaryMixedColumn } from "@features/autocomplete-table/autocomplete-table-list-columns/autocomplete-table-list-columns-mixed";

export const useAutocompleteTable = () => {
    const getResourceType = (type) => {
        if (type.indexOf("CONTENT") >= 0) return "CONTENT";
        else if (type.indexOf("ASSET") >= 0) return "ASSET";
        else if (type.indexOf("COLLECTION") >= 0) return "COLLECTION";
        else if (type.indexOf("LINK") >= 0) return "LINK";
    };
    const getTableColumns = (type, subType) => {
        if (type === "ASSET") {
            if (subType === "PREVIEW") return PreviewAssetColumn;
            return AssetColumn;
        } else if (type === "CONTENT") {
            switch (subType) {
                case "VIDEO":
                    return VideoContentColumn;
                case "MUSIC":
                    return MusicContentColumn;
                case "PEOPLE":
                    return PeopleContentColumn;
                case "PHOTO":
                    return PhotoContentColumn;
                case "CUSTOM":
                    return CustomContentColumn;
            }
        } else if (type === "COLLECTION") {
            return CollectionColumn;
        } else if (type === "LINK") {
            return LinkContentColumn;
        }
    };

    /* 검색/추가 다이얼로그(검색 결과 행) 전용 컬럼.
       에셋은 디스플레이용 AssetColumn 대신 컴팩트 컬럼(SearchedAssetColumn)을 사용한다. */
    const getSearchTableColumns = (type, subType) => {
        if (type === "ASSET") {
            if (subType === "PREVIEW") return PreviewAssetColumn;
            return SearchedAssetColumn;
        }
        return getTableColumns(type, subType);
    };

    const getSmallTableColumns = (type, subType) => {
        if (type === "ASSET") {
            switch (subType) {
                case "PREVIEW":
                    return PreviewAssetColumn;
                default:
                    return SummaryMixedColumn;
            }
        } else if (type === "CONTENT") {
            switch (subType) {
                case "VIDEO":
                    return VideoContentColumn;
                case "MUSIC":
                    return MusicContentColumn;
                case "PEOPLE":
                    return PeopleContentColumn;
                case "PHOTO":
                    return PhotoContentColumn;
                case "CUSTOM":
                    return CustomContentColumn;
            }
        } else if (type === "COLLECTION") {
            return CollectionColumn;
        } else if (type === "LINK") {
            return LinkContentColumn;
        }
    };
    const getSubNameIds = (type, subType) => {
        if (type === "ASSET") {
            switch (subType) {
                case "VIDEO":
                case "AUDIO":
                    return ["extensions", "duration", "size"];
                case "IMAGE":
                case "CAPTION":
                    return ["extensions", "size"];
                case "PREVIEW":
                    return ["extensions"];
                case "FILE":
                    return ["extensions", "size"];
                default:
                    return ["extensions", "size"];
            }
        } else if (type === "CONTENT") {
            switch (subType) {
                case "VIDEO":
                    return ["extensions"];
                case "MUSIC":
                case "PEOPLE":
                case "PHOTO":
                case "CUSTOM":
                    return [];
            }
        } else if (type === "COLLECTION") {
            return [];
        } else if (type === "LINK") {
            return [];
        }
    };

    return {
        getResourceType,
        getTableColumns,
        getSearchTableColumns,
        getSmallTableColumns,
        getSubNameIds,
    };
};
